<template>
    <div :style="{backgroundColor:getCourseSubColor(courseId)}">
        <HeaderNav :navtitle="obj240WordsLessonHomeInfo.lessonTitle" :beforecolor="'#fff'"
                   :backcolor="getCourseMainColor(courseId)"
                   :innerPageArticleId="obj240WordsLessonHomeInfo.innerPageArticleId"
                   @returnBack="goToBack" @goInsidePages="goInsidePages"/>
        <!-- 标题 -->
        <div :style="{backgroundColor: getCourseMainColor(courseId)}">
            <div class="lesson_title">{{obj240WordsLessonHomeInfo.name}}</div>
            <div class="lesson_vocabulary">{{obj240WordsLessonHomeInfo.vocabularyStrategy}}</div>
            <div class="clear"></div>
        </div>

        <!-- 音频播放 -->
        <div class="audio_title" :style="{color: getCourseMainColor(courseId)}">
            {{obj240WordsLessonHomeInfo.explainAudioTitle}}
        </div>

        <!-- 播放视图 -->
        <div class="lesson_audio">
            <div class="info">
                <div class="title">学前听一听</div>
                <div class="mp3_progress">
                    <div class="now_progress" v-bind:style="{width: progress+ '%'}"></div>
                </div>
                <div class="time">
                    <div class="time_start">{{realFormatSecond(currentTime)}}</div>
                    <div class="time_end">{{obj240WordsLessonHomeInfo.explainAudioDurationDisplayString}}</div>
                    <div class="clear"></div>
                </div>
            </div>
            <div class="play" @click="changeStart">
                <audio v-bind:src="$qiNiuDomainBase + obj240WordsLessonHomeInfo.explainAudio" id="musicMp3"
                       controls=""></audio>
                <img v-if="!isPlay" src="@/assets/player_play.png" height="40" width="40"/>
                <img v-else src="@/assets/player_pause.png" height="40" width="40"/>
            </div>
            <div class="clear"></div>
        </div>

        <!-- Part1 -->
        <div class="part_title" :style="{color:getCourseWordColor(courseId)}">Part 1</div>
        <div class="explain" @click="partExplainClick(1, 0, '')">
            <div class="explain_left">
                <div :style="{color: getCourseWordColor(courseId)}">
                    <i class="icon-light icon_part"></i>
                </div>
            </div>
            <div class="explain_center">
                <span class="explain_title">学前准备 / 生词卡</span>
            </div>
        </div>

        <div>
            <ul class="sentence_list">
                <li v-for="(item, index) in obj240WordsLessonHomeInfo.part1SentenceArray" :key="index"
                    @click="sentenceClick(1, index + 1, 0, '')">
                    <div class="sentence_item_left">
                        <div class="no" :style="{color:getCourseWordColor(courseId)}"># {{index + 1}}</div>
                    </div>
                    <div class="sentence_item_center">
                        <div class="name">{{item.sentence}}</div>
                    </div>
                    <div class="sentence_item_right">
                        <img class="img_finish" v-if="item.finish === 1" src="@/assets/activity_finish.png" height="25"
                             width="25"/>
                        <span v-else>未完成</span>
                    </div>
                    <div class="clear"></div>
                </li>
            </ul>
        </div>

        <!-- Part1练习、Part2、Part3 -->
        <div v-for="(item, index) in obj240WordsLessonHomeInfo.partArray" :key="index">
            <div class="part_title" :style="{color:getCourseWordColor(courseId)}">{{genePartName(item.partNo)}}</div>

            <div class="explain" @click="partExplainClick(item.partNo, 0, getCount(item.countB) == 0 ? '' : 'A')">
                <div class="explain_left">
                    <div :style="{color: getCourseWordColor(courseId)}">
                        <i class="icon-light icon_part"></i>
                    </div>
                </div>
                <div class="explain_center">
                    <span class="explain_title">学前准备 / 生词卡</span>
                </div>
            </div>

            <!-- PartA 或 无A、B Part -->
            <div>
                <ul class="sentence_list"
                    @click="sentenceClick(item.partNo, 1, 0, getCount(item.countB) == 0 ? '' : 'A')">
                    <li>
                        <div class="sentence_item_left">
                            <div :style="{color: getCourseWordColor(courseId)}">
                                <i class="icon-exercise icon_part"></i>
                            </div>
                        </div>
                        <div class="sentence_item_center">
                            <div class="name">{{showExerciseTitle(item.countA, item.countB)}}</div>
                        </div>
                        <div class="sentence_item_right">
                            <img class="img_finish" v-if="getCount(item.countA) === getCount(item.finishCountA)"
                                 src="@/assets/activity_finish.png" height="25"
                                 width="25"/>
                            <span v-else>未完成</span>
                        </div>
                        <div class="clear"></div>
                    </li>
                </ul>
            </div>
            <!-- PartB -->
            <div v-if="getCount(item.countB) > 0">
                <ul class="sentence_list" @click="sentenceClick(item.partNo, 1, 1, 'B')">
                    <li>
                        <div class="sentence_item_left">
                            <div :style="{color: getCourseWordColor(courseId)}">
                                <i class="icon-exercise icon_part"/>
                            </div>
                        </div>
                        <div class="sentence_item_center">
                            <div class="name">{{showExerciseTitleB(item.countB)}}</div>
                        </div>
                        <div class="sentence_item_right">
                            <img class="img_finish" v-if="getCount(item.countB) === getCount(item.finishCountB)"
                                 src="@/assets/activity_finish.png" height="25"
                                 width="25"/>
                            <span v-else>未完成</span>
                        </div>
                        <div class="clear"></div>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Quiz4 -->
        <div class="part_title" :style="{color:getCourseWordColor(courseId)}">Quiz 4</div>
        <div>
            <ul class="sentence_list" @click="quizClick()">
                <li>
                    <div class="sentence_item_left">
                        <div :style="{color: getCourseWordColor(courseId)}">
                            <i class="icon-exercise icon_part"></i>
                        </div>
                    </div>
                    <div class="sentence_item_center">
                        <div class="name">{{showExerciseTitle(obj240WordsLessonHomeInfo.quizCount, 0)}}</div>
                    </div>
                    <div class="sentence_item_right">
                        <img class="img_finish"
                             v-if="getCount(obj240WordsLessonHomeInfo.quizCount) === getCount(obj240WordsLessonHomeInfo.quizFinishCount)"
                             src="@/assets/activity_finish.png" height="25"
                             width="25"/>
                        <span v-else>未完成</span>
                    </div>
                    <div class="clear"></div>
                </li>
            </ul>
        </div>
        <div class="sentence_list_bottom"></div>

    </div>
</template>

<script>
    export default {
        name: "index",
        data() {
            return {
                courseId: 0,
                lessonId: 0,
                obj240WordsLessonHomeInfo: {},
                progress: 0,
                isPlay: false,
                currentTime: 0,
                mTimer: null
            }
        },
        methods: {
            goToBack() {
                this.goBack(this.$router);
            },
            goInsidePages:function(id){
                this.$router.push({name: 'pageView', query: {url: "https://xiaohuasheng.cn/mtesthome_"+ id +"/come_1"}});
            },
            genePartName(partNo) {
                return partNo === -1 ? "Part 1 练习" : "Part " + partNo;
            },
            showExerciseTitle(countA, countB) {
                return (this.getCount(countB) === 0 ? "" : "A: ") + "#1 ~ #" + this.getCount(countA);
            },
            showExerciseTitleB(countB) {
                return "B: #1 ~ #" + this.getCount(countB);
            },
            partExplainClick(partNo, group, groupName) {
                let vLessonTitle = this.obj240WordsLessonHomeInfo.lessonTitle + " " + this.genePartName(partNo);

                if (!this.isEmpty(groupName)) {
                    vLessonTitle = vLessonTitle + "-" + groupName;
                }

                this.$router.push({
                    name: "lessonPart",
                    query: {
                        courseId: this.obj240WordsLessonHomeInfo.courseId,
                        lessonId: this.obj240WordsLessonHomeInfo.pk,
                        partNo: partNo,
                        lessonTitle: vLessonTitle,
                        group: group, groupName: groupName
                    }
                });
            },
            sentenceClick(partNo, sentenceIndex, group, groupName) {
                let vLessonTitle = this.obj240WordsLessonHomeInfo.lessonTitle + " " + this.genePartName(partNo);

                if (!this.isEmpty(groupName)) {
                    vLessonTitle = vLessonTitle + "-" + groupName;
                }

                this.$router.push({
                    name: "Sentence",
                    query: {
                        courseId: this.courseId,
                        lessonId: this.lessonId,
                        partNo: partNo,
                        sentenceIndex: sentenceIndex,
                        lessonTitle: vLessonTitle,
                        group: group,
                        groupName: groupName
                    }
                });
            },
            quizClick() {
                this.$router.push({
                    name: "lessonQuiz",
                    query: {
                        courseId: this.courseId,
                        lessonId: this.lessonId,
                        quizCount: this.obj240WordsLessonHomeInfo.quizCount,
                        lessonTitle: this.obj240WordsLessonHomeInfo.lessonTitle
                    }
                });
            },
            changeStart: function () {
                let that = this;
                that.isPlay = !that.isPlay
                const musicMp3 = document.getElementById('musicMp3')
                if (that.isPlay) {
                    if (that.mTimer == null) {
                        that.changeProgress();
                    }
                    musicMp3.play()
                } else {
                    musicMp3.pause()
                }
            },
            changeProgress: function () {
                let that = this;
                const musicMp3 = document.getElementById('musicMp3')

                that.mTimer = setInterval(() => {
                    const numbers = musicMp3.currentTime / musicMp3.duration
                    let perNumber = (numbers * 100).toFixed(2)
                    if (perNumber >= 100) {
                        that.isPlay = false
                        that.progress = 0
                        that.currentTime = 0
                        clearInterval(that.mTimer)
                        that.mTimer = null;
                    } else {
                        that.progress = perNumber
                        that.currentTime = musicMp3.currentTime;
                    }
                }, 50)
            },
            callChangeProgress: function () {
                let that = this;
                document.getElementById('musicMp3').pause()
                that.changeProgress()
            }
        },
        mounted: function () {
            this.callChangeProgress();
            window.LessonScrollTop = 0;
        },
        beforeRouteLeave(to, from, next) {
            window.LessonScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            next()
        },
        activated() {
            window.scrollTo(0, window.LessonScrollTop);
            let that = this;

            if (window.LessonRefreshData != null && this.getCount(window.LessonRefreshData) === 1) {
                window.LessonRefreshData = 0;

                that.$axios.get("240words/getLessonHomeInfo/" + that.lessonId).then((response) => {
                    that.obj240WordsLessonHomeInfo = response.data;
                }).catch(function (error) {
                    window.console.log(error)
                });
            }
        },
        beforeCreate() {
            let that = this;
            let vCourseId = parseInt(that.$route.query.courseId);
            let vLessonId = parseInt(that.$route.query.lessonId);
            let url = "240words/getLessonHomeInfo/" + vLessonId;
            that.$axios.get(url).then((response) => {
                that.courseId = vCourseId;
                that.lessonId = vLessonId;
                that.obj240WordsLessonHomeInfo = response.data;
                window.console.log(JSON.stringify(that.obj240WordsLessonHomeInfo));
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    .lesson_title {
        padding-top: 20px;
        text-align: center;
        font-size: 40px;
        font-weight: bold;
        color: #ffffff;
        line-height: 40px;
    }

    .lesson_vocabulary {
        text-align: center;
        font-size: 16px;
        color: #ffffff;
        line-height: 20px;
        padding-top: 5px;
        padding-bottom: 20px;
    }

    .audio_title {
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        margin-top: 30px;
        margin-bottom: 20px;
    }

    .part_title {
        text-align: center;
        font-size: 40px;
        font-weight: bold;
        color: #275ba9;
        line-height: 40px;
        margin-top: 40px;
        margin-bottom: 20px;
    }

    .explain {
        background-color: white;
        margin: 0px 10px 15px 10px;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        padding: 15px;
        position: relative;
    }

    .explain .explain_left {
        float: left;
        width: 70px;
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
    }

    .explain .explain_center {
        margin-left: 80px;
        text-align: left;
    }

    .explain .explain_center .explain_title {
        font-size: 19px;
        font-weight: bold;
        color: #333;
        line-height: 32px;
    }

    .sentence_list {
        padding-top: 15px;
    }

    .sentence_list:first-child {
        padding-top: 0px;
    }

    .sentence_list:last-child {

    }

    .sentence_list li {
        background-color: white;
        margin: 0px 10px 15px 10px;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        padding: 15px;
        position: relative;
    }

    .sentence_list li .sentence_item_left {
        float: left;
        width: 70px;
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
    }

    .sentence_list li .sentence_item_left .no {
        font-size: 25px;
        font-weight: bold;
        color: #275ba9;
        line-height: 32px;
    }

    .icon_part {
        text-align: center;
        font-size: 30px;
        line-height: 32px;
        margin-left: 5px;
    }

    .sentence_list li .sentence_item_center {
        margin-left: 80px;
        width: calc(100% - 150px);
        text-align: left;
    }

    .sentence_list li .sentence_item_center .name {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        line-height: 32px;
    }

    .sentence_list li .sentence_item_right {
        width: 70px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
    }

    .sentence_list li .sentence_item_right .img_finish {
        position: absolute;
        top: 50%;
        right: 15px;
        -webkit-transform: translateY(-50%);
    }

    .sentence_list li .sentence_item_right span {
        position: absolute;
        right: 15px;
        font-size: 15px;
        color: #999999;
        top: 50%;
        -webkit-transform: translateY(-50%);
    }

    .sentence_list_bottom {
        height: 50px;
    }

    .lesson_audio {
        position: relative;
        background-color: white;
        margin: 20px 20px 0px 20px;
        padding: 15px;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
    }

    .lesson_audio .info {
        margin-right: 50px;
    }

    .lesson_audio .play {
        position: absolute;
        top: 50%;
        right: 15px;
        -webkit-transform: translateY(-50%);
    }

    .lesson_audio .info .title {
        font-size: 15px;
        font-weight: bold;
        color: #333333;
    }

    .lesson_audio .info .mp3_progress {
        width: 100%;
        height: 4px;
        background-color: #f4f4f4;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .lesson_audio .info .now_progress {
        position: relative;
    @extend % transition;
        height: 4px;
        background-color: #64c846;
    }

    .lesson_audio .time {
        font-size: 12px;
        color: #999999;
    }

    .lesson_audio .time .time_start {
        float: left;
    }

    .lesson_audio .time .time_end {
        float: right;
    }

    audio {
        display: none;
    }

</style>
